import clsx from 'clsx';

import { ICallOut, State } from '../components/CallOut';

const variantMapping = {
  subtle: 'CallOut--subtle',
  default: 'CallOut--default',
  negative: 'CallOut--negative',
  positive: 'CallOut--positive',
  warning: 'CallOut--warning',
  internal: 'CallOut--internal',
  invisible: 'CallOut--invisible',
};

const sizeMapping = {
  small: 'CallOut--small',
  tiny: 'CallOut--tiny',
};

export function classNameForCallOut(
  { modifierClassName, variant = 'default', size }: ICallOut,
  state: State
) {
  const { collapsed } = state;
  const variantClassName = variantMapping[variant];
  let sizeClassName = '';
  if (size) {
    sizeClassName = sizeMapping[size];
  }

  return clsx('CallOut', modifierClassName, variantClassName, sizeClassName, {
    'CallOut--collapsed': collapsed,
  });
}

export function classNameForCallOutContent(props: ICallOut, state: State) {
  const { collapsed } = state;
  const { Icon } = props;

  return clsx('CallOut-content', {
    'CallOut-content--collapsed': collapsed,
    'CallOut-content--expanded': !collapsed,
    'CallOut-hasIcon': Icon,
  });
}

export function classNameForCallOutToggle(state: State) {
  const { collapsed } = state;

  return clsx('CallOut-expandToggle', {
    'CallOut-expandToggle--expanded': !collapsed,
  });
}
